import React, {useState} from 'react';

import '../Tutorial.css';
import {useActions} from '../../../hooks/useActions';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T10Welcome() {

    const {setTutorial} = useActions();
    const [showNext, setShowNext] = useState(false);
    const atEnd = () =>{
        setShowNext(true);
    }
  /*  useEffect(() => {
        UserService.sendEvent('Welcome10');
    }, []); */

    const text = "Welcome to the Depraved World — a land of true pleasure, bestowed upon us by the Goddess herself. Learn, conquer, and embrace your desires with passion, for those who do will be blessed with incredible power and might.";

    return (
        <div className='welcome10Container'>

            <TutorialGirl/>

            <div className='tutorialContainer tutorialBottomContainer'>
                <div className='tutorialBottomTextField'>
                    <Typewriter
                        options={{
                            delay: 30
                        }}
                        onInit={(typewriter) => {
                            typewriter.typeString(text).start().callFunction(atEnd);
                        }}
                    />
                </div>
                {(showNext)?
                    <div className={'tutorialButton defaultButtonAnimation'} onClick={() => {
                        setTutorial({isActive: true, step: 'ClickBossOnMap20'});
                    }}>
                    </div>
                    : <div className={'tutorialButtonPlaceholder'}></div>
                }
            </div>
            <div className={'clickBoss20Bottom'}></div>
        </div>

    );
}

export default T10Welcome;